<template>
  <label class="formlabel" :class="{'formlabel_required': required, 'formlabel_checkboxmode': checkboxmode, 'formlabel_witherror':error, 'formlabel_ok':ok}">
    <span v-if="text" class="formlabel__text" :class="{'formlabel__text_increased' : increased}">{{text}}</span>
    <slot />
    <span v-if="checkboxmode" class="formlabel__descr" v-html="descr"></span>
    <span class="formlabel__error" v-if="error">{{error}}</span>
  </label>
</template>
<script>
export default {
  props: {
    required: { type: Boolean, default: false },
    ok: {type: Boolean, default: false},
    text: {type: String},
    error: {type: String},
    checkboxmode: {type: Boolean, default: false},
    descr: {type: String},
    increased: {type: Boolean, default: false},
  }
}
</script>

<style lang="sass">
.formlabel
  padding-top: 10px
  width: calc(100% - var(var(--labelspace)))
  margin-right: var(--labelspace)
  display: block
  position: relative
  box-sizing: border-box
  margin-bottom: 40px
  z-index: 2
  &:focus-within
    z-index: 3
  .formfield
    margin-bottom: 4px
  padding-left: 0px
  padding-right: 16px
  &_checkboxmode
    border: none !important
    display: flex
    align-items: flex-start
    width: 100%
    margin-right: 0
    margin-top: 0
  &_required &__text::after
    content: '*'
    color: colors.$newred
    font-weight: 400
    width: 0
    overflow: visible
    display: inline-block
    transform: translateY(-1px)    
  &__text
    display: block
    font-size: 12px
    line-height: 18px
    color: colors.$newgray
    transition: .3s ease
    padding-right: 24px
  &__descr
    margin-left: 16px
    font-size: 14px
    line-height: 24px
    color: colors.$newgray
    a, a:hover
      text-decoration: none
      color: colors.$newred
  transition: border-color .3s ease-out
  border-bottom: 1px solid colors.$moar_silver_for_the_god_of_silver
  @include for-mob
    margin-bottom: 32px
  &.filled
    border-bottom: 1px solid colors.$newgray
    box-shadow: 0px 2px 0px -1px colors.$newgray
  /*
    &.disabled
      border-color: transparent !important
  .formlabel__text_increased
    transform: translateY(10px)
    font-size: 16px
  /*
    &:focus-within, &.filled
      .formlabel__text_increased
        font-size: 13px
        line-height: 18px
        transform: none
  &:focus-within .aoformdroplist
    display: block

  &__error
    position: absolute
    white-space: nowrap
    top: calc(100% + 5px)
    left: 0
    font-size: 12px
    line-height: 24px
    letter-spacing: 0.02em
    color: colors.$newred
  &.formlabel_witherror
    border-bottom-color: colors.$newred
  &:focus-within
    border-color: colors.$newgray
  /*
    &_ok:not(&_witherror)
      &::after
        content: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcgMTJMMTAgMTVMMTcgOCIgc3Ryb2tlPSIjMDBCOTJEIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=)
        width: 24px
        height: 24px
        position: absolute
        left: calc(100% + 7px)
        bottom: 16px
  &:focus-within .aoformdroplist
    pointer-events: auto
    opacity: 1
  &:not(:focus-within) .aoformdroplist
    transition: pointer-events .05s, opacity .05s      
</style>